var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-menu',{attrs:{"offset-y":"","absolute":"","close-on-content-click":false},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('div',_vm._g({style:(`
        position: absolute;
        left: ${_vm.tagRect.x}px;
        top: ${_vm.tagRect.y}px;
      `)},on),[_c('div',{staticClass:"tag",style:(`
          width: ${_vm.tagRect.w}px;
          height: ${_vm.tagRect.h}px;`),on:{"mouseover":_vm.onMouseOver,"mouseleave":_vm.onMouseLeave}}),(_vm.memberChip && _vm.hover)?_c('div',{style:(`
          position: absolute;
          bottom: -36px;
          width: 500%;
          left: ${_vm.tagRect.w / 2}px;
          transform: translateX(-50%);
          z-index: 1;
          text-align: center;
        `)},[_c('v-chip',{staticClass:"white",attrs:{"pill":""}},[_c('v-avatar',{attrs:{"left":""}},[_c('img',{staticClass:"primary",attrs:{"src":_vm.memberChip.picture}})]),_vm._v(" "+_vm._s(_vm.memberChip.name)+" ")],1)],1):_vm._e()])]}}]),model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[(_vm.editMode)?_c('v-card',{staticClass:"px-4 pt-4",attrs:{"max-width":"360px"}},[_c('FbMemberAutocomplete',{attrs:{"clearable":""},model:{value:(_vm.tag.member),callback:function ($$v) {_vm.$set(_vm.tag, "member", $$v)},expression:"tag.member"}}),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{staticClass:"error--text",attrs:{"text":""},on:{"click":_vm.deleteTag}},[_vm._v(" Delete ")])],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }